import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import { setup, isSupported } from '@loomhq/loom-sdk';
import loomLogo from '../../logos/loom.png';

function LoomSDKRecord({ autoTriggerRecord, onInsertClicked }) {
  const ref = useRef(null);
  const [loom, setLoom] = useState(null);
  const [sdkButton, setSdkButton] = useState(null);
  const [isRecording, setIsRecording] = useState(false);

  useEffect(() => {
    if (loom) return;

    isSupported().then(({ supported, error }) => {
      if (supported) {
        setup({ apiKey: process.env.LOOM_API_KEY }).then(setLoom);
      }
    });
  }, [loom]);

  useLayoutEffect(() => {
    if (!ref.current || loom === null) return;

    if (sdkButton) {
      return;
    }

    const loomSdkButton = loom.configureButton({
      element: ref.current,
      hooks: {
        onInsertClicked: (shareLink) => {
          onInsertClicked(shareLink);
        },
        onStart: () => {
          setIsRecording(true);
        },
        onCancel: () => {
          setIsRecording(false);
        },
        onComplete: () => {
          setIsRecording(false);
        },
      },
    });

    if (autoTriggerRecord) {
      loomSdkButton.openPreRecordPanel();
    }

    setSdkButton(loomSdkButton);

    return function cleanup() {
      loom.teardown();
    };
  }, [loom, sdkButton, onInsertClicked, autoTriggerRecord]);

  return (
    <div ref={ref}>
      <button
        type='button'
        className='btn-bedrock-secondary flex items-center space-x-1 text-center w-full justify-center'
        disabled={isRecording}
        onClick={() => sdkButton && sdkButton.openPreRecordPanel()}
      >
        <img alt='Record Loom Button' src={loomLogo} className='w-4 h-4' />
        {isRecording ? <span>Recording..</span> : <span>Record Loom</span>}
      </button>
    </div>
  );
}

LoomSDKRecord.defaultProps = {
  autoTriggerRecord: false,
  onInsertClicked: () => {},
};

export default LoomSDKRecord;
